import React from 'react';

// Styles
import './FeaturedIcon.scss';

interface FeaturedIconProps {
  icon: React.ReactNode;
  style: React.CSSProperties;
}

export default function FeaturedIcon({ icon, style }: FeaturedIconProps) {
  return (
    <div className="featured-icon__circle" style={style}>
      {icon}
    </div>
  );
}
